<gd-e-commerce-store-selection-modal [storesList]="storesList$ | async" (storeSelect)="selectStore($event)">
</gd-e-commerce-store-selection-modal>
